"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isHtmlEvent = function isHtmlEvent(event) {
  return !!(event !== null && event !== void 0 && event.type && event.target && event.currentTarget && event.preventDefault);
};
var _default = exports["default"] = isHtmlEvent;